import React, { forwardRef } from 'react'

const ScalableWrapper = forwardRef(({ className, children }, ref) => {
  return (
    <div className={className} ref={ref}>
      {children}
    </div>
  )
})

export default ScalableWrapper
